<template>
  <div class="page-view">
    <!-- 整体区域 -->
    <div class="section-wrapper">
      <!-- 标题 start -->
      <div class="content-title">新增车辆数据导出任务</div>
      <!-- 标题 end -->

      <!-- 内容部分 start -->
      <div class="content-section">
        <!-- 内容操作 -->
        <div class="wrapper">
          <!-- 左侧部分 -->
          <div class="wrapper-left">
            <!-- 任务ID -->
            <div class="item task-code">
              <span class="item-title">任务ID</span>
              <div class="item-content">{{ forms.taskNo }}</div>
            </div>

            <!-- 选择时间 -->
            <div class="item select-time">
              <span class="item-title">选择时间</span>
              <div class="item-content">
                <el-date-picker
                  v-model="forms.timeRange"
                  type="daterange"
                  range-separator="到"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>

            <!-- 已选车辆 -->
            <div class="item select-vehicle">
              <span class="item-title">已选车辆</span>
              <div class="item-content">
                <el-tag :key="tag.vehicleId" v-for="tag in dynamicTags">
                  {{ tag.vehicleNum }}
                </el-tag>
              </div>
            </div>
          </div>

          <!-- 右侧区域 -->
          <div class="wrapper-right">
            <!-- 标题 -->
            <div class="vehicle-title">选择车辆</div>

            <!-- 车辆查询 -->
            <div class="vehicle-search">
              <div class="vehicle-search_left">
                <span class="text">已选择车辆：</span>
                <span class="num">{{ dynamicTags.length }}</span>
                <span class="clear" @click="handleClear()">清空选择</span>
              </div>
              <div class="vehicle-search_right">
                <el-input
                  class="search-input"
                  clearable
                  placeholder="公司名称"
                  v-model="filterOrganization"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleFilterOrganization"
                  ></el-button>
                </el-input>
              </div>
            </div>

            <!-- 操作车辆 -->
            <div
              class="vehicle-operate"
              v-loading="vehicleTreeLoding"
              element-loading-text="数据加载中"
            >
              <el-radio-group
                v-model="companyId"
                @change="getVehicleListByCompanyId"
              >
                <div
                  class="check-item"
                  v-for="(item, index) in showData"
                  :key="index"
                >
                  <el-radio :label="item.value">{{ item.label }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </div>
        </div>

        <!-- 按钮操作 start -->
        <div class="operate-section">
          <el-button class="save" :loading="saveLoading" @click="handleSave()"
            >保存</el-button
          >
          <button class="cancel" @click="$router.push('vehicleDataExportList')">
            取消
          </button>
        </div>
        <!-- 按钮操作 end -->
      </div>
      <!-- 内容部分 end -->
    </div>
  </div>
</template>

<script>
import {
  getTaskNo,
  getVehicleListByCompanyId,
  saveExportDataTask
} from "@/api/systemSetting/vehicleDataExport";
import { FetchAllCustomer } from "@/api/systemSetting/interfaceUserManager";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      vehicleTreeLoding: false, // 车辆树
      forms: {
        taskNo: "",
        timeRange: [
          moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD HH:mm:ss")
        ],
        bTime: "",
        eTime: "",
        vehicleIdList: []
      },
      dynamicTags: [],
      vehicleList: [], // 车辆下拉list
      defaultProps: {
        children: "children",
        disabled: "null",
        label: "label"
      },
      filterOrganization: "", // 筛选值
      saveLoading: false,
      companyData: [],
      showData: [],
      companyId: ""
    };
  },
  watch: {
    // 监听用户输入内容
    filterOrganization(val) {
      if (this.filterOrganization === "") {
        this.$refs.tree.filter(val);
      }
    }
  },
  created() {
    this.getOrganization();
    this.getTaskNo(); // 获取任务id
    // this.getVehicleList(); // 获取车辆下拉树
  },
  methods: {
    // 获取任务id
    async getTaskNo() {
      let res = await getTaskNo();
      if (res.code === 1 && res.result) {
        this.forms.taskNo = res.result;
      }
    },
    getOrganization() {
      this.vehicleTreeLoding = true;
      FetchAllCustomer()
        .then(res => {
          if (res.code === 1 && res.result) {
            this.companyData = res.result;
            this.showData = res.result;
          }
          this.vehicleTreeLoding = false;
        })
        .catch(err => {
          this.vehicleTreeLoding = false;
          console.log(err);
        });
    },
    // 获取 车辆下拉树
    // async getVehicleList() {
    //   try {
    //     this.vehicleTreeLoding = true;
    //     let res = await getExportDataVehicleInfoTree();
    //     if (res && res.code === 1) {
    //       if (res.result && Array.isArray(res.result)) {
    //         this.vehicleList = res.result;
    //       }
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   } finally {
    //     this.vehicleTreeLoding = false;
    //   }
    // },

    async getVehicleListByCompanyId() {
      try {
        let res = await getVehicleListByCompanyId({
          companyId: this.companyId
        });
        if (res && res.code === 1) {
          console.log(res.result);
          this.dynamicTags = res.result || [];
        }
      } catch (err) {
        console.log(err);
      }
    },

    // 过滤部门方法
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 过滤部门
    handleFilterOrganization() {
      this.showData = this.companyData.filter(data => {
        return data.label.indexOf(this.filterOrganization) !== -1;
      });
    },

    // 清空车辆选择
    handleClear() {
      if (!this.dynamicTags.length) {
        this.$message.warning("未选择任何车辆");
        return;
      }
      this.$confirm("确认清空已选择车辆", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.companyId = "";
          this.dynamicTags = [];
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 取消已选车辆tag
    handleCloseTag(id) {
      this.dynamicTags.splice(
        this.dynamicTags.findIndex(item => {
          return item.id === id;
        }),
        1
      );
      this.$refs.tree.setCheckedNodes(this.dynamicTags);
    },

    // 保存提交
    handleSave() {
      if (!this.dynamicTags.length) {
        this.$message.warning("未选择任何车辆");
        return;
      }

      let start = moment(this.forms.timeRange[0]);
      let end = moment(this.forms.timeRange[1]);
      if (end.diff(start, "days") > 30) {
        this.$message.warning("开始时间与结束时间间隔不能大于31天");
        return;
      }

      let params = cloneDeep(this.forms);
      params.vehicleIdList = this.dynamicTags.map(item => item.vehicleId);
      params.bTime = start.format("YYYY-MM-DD");
      params.eTime = end.format("YYYY-MM-DD");
      delete params.timeRange;
      this.handleSumbit(params);
    },

    async handleSumbit(params) {
      this.saveLoading = true;
      let res = await saveExportDataTask(params);
      if (res && res.code === 1) {
        this.$message.success(res.message);
        this.$router.push("vehicleDataExportList");
      } else {
        this.saveLoading = false;
        this.$message.error(res.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
  .section-wrapper {
    height: 100%;
    // 标题
    .content-title {
      padding: 15px;
      color: #333;
      font-size: 16px;
    }

    //内容部分
    .content-section {
      height: calc(100% - 50px - 20px);
      padding: 20px 20px 0;
      border: 1px solid #e6e6e6;
      border-radius: 3px;
      margin: 0 20px 20px;
      box-sizing: border-box;
      // 展示选择车辆区域
      .wrapper {
        display: flex;
        flex-direction: row;
        height: calc(100% - 60px);

        &-left,
        &-right {
          flex: 1;
          border: 2px solid #eae5e5;
          border-radius: 5px;
        }

        // 左侧区域
        &-left {
          margin-right: 15px;

          .item {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 20px 20px 0;

            // 标题
            &-title {
              width: 65px;
              font-size: 16px;
              text-align: right;
            }

            // 内容
            &-content {
              width: calc(100% - 80px);
              margin-left: 20px;
            }
          }

          // 已选车辆
          .select-vehicle {
            height: calc(100% - 38px - 88px);
            padding-bottom: 20px;

            .item-title,
            .item-content {
              height: 100%;
            }

            // 内容区块
            /deep/ .item-content {
              box-shadow: 0 0 5px 2px #bcbcbc;
              border-radius: 5px;
              overflow: auto;

              .el-tag--mini {
                height: 28px;
                padding: 0 10px;
                line-height: 28px;
                width: 50%;
              }

              .el-tag {
                font-size: 14px;
                background-color: transparent;
                border-color: transparent;
                .el-icon-close {
                  font-size: 16px;
                  top: 1px;
                }
              }
            }
          }
        }

        // 右侧区域
        &-right {
          margin-left: 15px;

          .vehicle {
            // 标题
            &-title {
              font-size: 14px;
              text-align: center;
              color: #333;
              background-color: #f2f2f2;
              padding: 15px 0;
            }

            // 搜索查询区域
            &-search {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 15px;
              border-bottom: 1px solid #eeeeee;

              &_left {
                display: flex;
                flex-direction: row;
                align-items: center;

                // 已选车辆
                .text {
                  color: #aeaeae;
                }

                // 选择车辆数
                .num {
                  display: block;
                  width: 22px;
                  height: 22px;
                  line-height: 22px;
                  font-size: 13px;
                  text-align: center;
                  color: #fff;
                  background-color: rgba(3, 169, 244, 0.45);
                  border-radius: 50%;
                  margin-left: 4px;
                }

                // 清空选择
                .clear {
                  color: rgba(3, 169, 244, 0.5);
                  cursor: pointer;
                  margin-left: 7px;
                }
              }
            }

            // 车辆操作选择
            &-operate {
              height: calc(100% - 46px - 59px - 40px);
              padding: 20px;
              overflow: auto;
              background-color: #fff;
              .check-item {
                line-height: 24px;
              }
            }
          }
        }
      }

      // 底部按钮操作部分
      .operate-section {
        height: 60px;
        line-height: 60px;
        text-align: center;

        // 按钮
        & > button {
          width: 78px;
          height: 30px;
          //line-height: 30px;
          border: none;
          border-radius: 3px;
          margin: 0 25px;
          font-size: 14px;
          cursor: pointer;
          outline-color: transparent;
          // 点击
          &:active {
            transition: all 0.5s;
            transform: scale(0.95);
          }

          // 鼠标移入
          &:hover {
            opacity: 0.95;
          }

          // 保存
          &.save {
            color: #fff;
            background-color: #5d70d6;
          }

          // 取消
          &.cancel {
            color: #5d70d6;
            background-color: #dfe2ee;
          }
        }
      }
    }
  }
}
</style>
